var ReportListComponent = (function () {
    function ReportListComponent() {
    }
    ReportListComponent.prototype.ngOnInit = function () {
    };
    return ReportListComponent;
}());
export { ReportListComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/report/report-list/report-list.component.ts.pre-build-optimizer.js